import React from 'react';

export const iconOverrides = {
  Airplane: (className: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g>
        <g id="Hintergrund" fill="none">
          <rect x="4" y="4" fill="none" width="16" height="16" />
          <rect y="0" width="24" height="24" />
        </g>
        <g id="Piktogramm">
          <path
            d="M19.6,10.6L19.6,10.6c0,0-2.2,0-5,0L9,3.3H7.2l3.3,7.4H8.7c-0.7,0-1.4,0.1-2.2,0.3l-1,0.2L3.1,8.7H2.2L3.1,12
  		l-1,3.3H3l2.4-2.4C6,13,6.5,13.1,6.5,13.1c0.8,0.2,1.5,0.3,2.2,0.3h1.8l-3.3,7.4H9l5.7-7.4h4.9l0,0c1.1,0,2.2-0.6,2.2-1.4
  		C21.9,11.2,20.7,10.6,19.6,10.6"
          />
        </g>
        <g fill="none">
          <path d="M24,24H0V0h24V24z M21.9,2.1H2.2v19.7h19.7C21.9,21.8,21.9,2.1,21.9,2.1z" />
        </g>
      </g>
      <g>
        <rect fill="none" width="24" height="24" />
      </g>
    </svg>
  ),
  Calendar: (className: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g>
        <path
          d="M6.273,7.636c0.452,0,0.818-0.366,0.818-0.818V4.091v0c0-0.452-0.366-0.818-0.818-0.818
     c-0.452,0-0.818,0.366-0.818,0.818v0v2.727C5.455,7.27,5.821,7.636,6.273,7.636z"
        />
        <path
          d="M19.091,5.455v1.364c0,0.753-0.611,1.364-1.364,1.364c-0.753,0-1.364-0.611-1.364-1.364h0V5.455H7.636v1.364
     c0,0.753-0.611,1.364-1.364,1.364c-0.753,0-1.364-0.611-1.364-1.364h0V5.455H3.273l0,14.182c0,0.6,0.491,1.091,1.091,1.091h15.273
     c0.6,0,1.091-0.49,1.091-1.09V5.455H19.091z M19.636,19.636C19.636,19.636,19.636,19.636,19.636,19.636
     c-0.001,0-0.002,0.001-0.003,0.001H4.367c-0.001,0-0.002-0.002-0.003-0.002c0,0,0,0,0,0L4.363,9.818h15.274L19.636,19.636z"
        />
        <path
          d="M17.727,7.636c0.452,0,0.818-0.366,0.818-0.818V4.091v0c0-0.452-0.366-0.818-0.818-0.818
     c-0.452,0-0.818,0.366-0.818,0.818v0v2.727C16.909,7.27,17.275,7.636,17.727,7.636z"
        />
        <rect x="8.255" y="10.909" width="1.867" height="1.912" />
        <rect x="11.056" y="10.909" width="1.867" height="1.912" />
        <rect x="13.857" y="10.909" width="1.867" height="1.912" />
        <rect x="5.455" y="13.777" width="1.867" height="1.912" />
        <rect x="8.255" y="13.777" width="1.867" height="1.912" />
        <rect x="11.056" y="13.777" width="1.867" height="1.912" />
        <rect x="16.657" y="10.909" width="1.867" height="1.912" />
        <rect x="16.657" y="13.777" width="1.867" height="1.912" />
        <rect x="5.455" y="16.64" width="1.867" height="1.912" />
        <rect x="8.255" y="16.64" width="1.867" height="1.912" />
        <rect x="11.056" y="16.64" width="1.867" height="1.912" />
        <rect x="13.857" y="16.64" width="1.867" height="1.912" />
        <polygon
          points="14.197,15.7 14.784,15.113 15.371,15.7 15.752,15.319 15.165,14.732 15.752,14.145 15.371,13.764 
     14.784,14.351 14.197,13.764 13.816,14.145 14.403,14.732 13.816,15.319 	"
        />
      </g>
    </svg>
  ),
  MedicalCrossBox: (className: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
    >
      <g>
        <g>
          <path
            d="M19.6,8.7h-0.5h-3.9V6.5c0-0.6-0.5-1.1-1.1-1.1H9.8C9.2,5.5,8.7,6,8.7,6.6v2.2H5.8H4.4
			c-0.6,0-1.1,0.5-1.1,1.1v8.9c0,0.6,0.5,1.1,1.1,1.1h1.4h13.4h0.5c0.6,0,1.1-0.5,1.1-1.1v-9C20.7,9.2,20.2,8.7,19.6,8.7z M9.8,6.6
			h4.4v2.2H9.8V6.6z M12,17.9c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1S13.7,17.9,12,17.9z"
          />
          <polygon
            points="12.6,13 11.4,13 11.4,14.2 10.1,14.2 10.1,15.5 11.4,15.5 11.4,16.7 12.6,16.7 12.6,15.5 13.9,15.5 
			13.9,14.2 12.6,14.2 		"
          />
        </g>
      </g>
      <rect fill="none" width="24" height="24" />
    </svg>
  ),
  IncompleteCircle: (className: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
    >
      <g>
        <g>
          <path
            d="M12,13.7c0.2,0,0.4-0.1,0.5-0.2l4.7-4.6c0.3-0.3,0.3-0.7,0-1c-0.2-0.2-0.7-0.3-1,0L12,12L9.4,9.4
			c-0.2-0.2-0.7-0.3-1,0s-0.3,0.7,0,1l3.1,3.1C11.6,13.6,11.8,13.7,12,13.7z"
          />
          <path
            d="M12,2.2c-2.4,0-4.7,0.9-6.4,2.4V2.2H4v5.5h5.5V6h-3C7.9,4.6,9.9,3.8,12,3.8c4.5,0,8.2,3.7,8.2,8.2
			s-3.7,8.2-8.2,8.2S3.8,16.5,3.8,12c0-1.1,0.2-2.2,0.7-3.2L3,8.2C2.5,9.3,2.2,10.6,2.2,12c0,5.4,4.4,9.8,9.8,9.8s9.8-4.4,9.8-9.8
			S17.4,2.2,12,2.2z"
          />
        </g>
      </g>
      <rect fill="none" width="24" height="24" />
    </svg>
  ),
  Magnifier: (className: string) => (
    <svg
      className={className}
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 13.4167H14.71L14.43 13.1579C15.41 12.0654 16 10.6471 16 9.10417C16 5.66375 13.09 2.875 9.5 2.875C5.91 2.875 3 5.66375 3 9.10417C3 12.5446 5.91 15.3333 9.5 15.3333C11.11 15.3333 12.59 14.7679 13.73 13.8287L14 14.0971V14.8542L19 19.6362L20.49 18.2083L15.5 13.4167ZM9.5 13.4167C7.01 13.4167 5 11.4904 5 9.10417C5 6.71792 7.01 4.79167 9.5 4.79167C11.99 4.79167 14 6.71792 14 9.10417C14 11.4904 11.99 13.4167 9.5 13.4167Z"
        fill="white"
      />
    </svg>
  ),
  CheckCircle: (className: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
    >
      <g id="Ebene_1">
        <g id="Symbol">
          <rect y="0" fill="none" width="24" height="24" />
          <path
            d="M12,3.3c-4.8,0-8.7,3.9-8.7,8.7s3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7S16.8,3.3,12,3.3z M10.9,16.3l-4.4-4.4
       L8,10.4l2.9,2.9l5-5l1.5,1.5L10.9,16.3z"
          />
        </g>
        <g id="SWISS_Hintergrund"></g>
        <g id="Piktogramm"></g>
      </g>
      <g id="Piktogramm_1_">
        <rect fill="none" width="24" height="24" />
      </g>
    </svg>
  ),
  AddLocation: (className: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      className={className}
    >
      <g id="SWISS_Hintergrund"></g>
      <g id="Piktogramm">
        <g>
          <path
            d="M11.99,3.32c-3.282,0-5.942,2.661-5.942,5.942c0,0.312,0.024,0.618,0.07,0.916
  		c0.053,0.342,0.136,0.673,0.245,0.993c0.048,0.14,0.1,0.278,0.158,0.414c1.219,2.867,5.447,9.189,5.447,9.189
  		s4.243-6.314,5.479-9.157c0.073-0.168,0.138-0.34,0.195-0.516c0.098-0.3,0.173-0.61,0.222-0.93c0.045-0.296,0.069-0.6,0.069-0.909
  		C17.933,5.98,15.272,3.32,11.99,3.32z M11.967,13.27c-2.213,0-4.008-1.794-4.008-4.008c0-2.213,1.794-4.008,4.008-4.008
  		s4.008,1.794,4.008,4.008C15.975,11.475,14.181,13.27,11.967,13.27z"
          />
        </g>
      </g>
    </svg>
  ),
  Info: (className: string) => (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1128_9610)">
        <path d="M10.0005 2.72607C5.98506 2.72607 2.72656 5.98457 2.72656 9.99997C2.72656 14.0154 5.98506 17.2739 10.0005 17.2739C14.0159 17.2739 17.2744 14.0154 17.2744 9.99997C17.2744 5.98457 14.0159 2.72607 10.0005 2.72607ZM10.0005 5.31748C10.5393 5.31748 10.9754 5.75366 10.9754 6.29246C10.9754 6.83127 10.5393 7.26745 10.0005 7.26745C9.46165 7.26745 9.02547 6.83127 9.02547 6.29246C9.02547 5.75366 9.46165 5.31748 10.0005 5.31748ZM12.4379 14.0923H7.563V13.1174H9.02547V9.21742H8.05049V8.24243H10.9754V13.1174H12.4379V14.0923Z" />
      </g>
      <defs>
        <clipPath id="clip0_1128_9610">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  LockFilled: (className: string) => (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_911_3486)">
        <path d="M8.93283 8.35208C8.93283 6.66089 10.3087 5.28498 11.9999 5.28498C13.6911 5.28498 15.067 6.66089 15.067 8.35208V9.81812H17.0793V8.35208C17.0793 5.55129 14.8008 3.27267 11.9999 3.27267C9.19915 3.27267 6.92053 5.55129 6.92053 8.35208V9.81812H8.93283V8.35208Z" />
        <path d="M5.78442 10.3636V20.7273H18.2155V10.3636H5.78442ZM12.7781 15.7454V18.5454H11.2243V15.7468C10.7596 15.4782 10.4461 14.9771 10.4461 14.4018C10.4461 13.5436 11.1418 12.8479 12 12.8479C12.8582 12.8479 13.5538 13.5436 13.5538 14.4018C13.5538 14.9761 13.2415 15.4764 12.7781 15.7454Z" />
      </g>
      <defs>
        <clipPath id="clip0_911_3486">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Pin: (className: string) => (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_883_6883)">
        <path d="M9.99935 1.66669C6.7777 1.66669 4.16602 4.20723 4.16602 7.34111C4.16602 7.63871 4.18982 7.93086 4.23523 8.21611C4.28713 8.54229 4.36896 8.8587 4.47542 9.16409C4.52211 9.298 4.57372 9.42971 4.63016 9.55892C5.82637 12.2965 9.97676 18.3334 9.97676 18.3334C9.97676 18.3334 14.1415 12.304 15.3553 9.58957C15.427 9.4292 15.4906 9.26463 15.5467 9.09676C15.6425 8.81005 15.7167 8.51385 15.7648 8.20913C15.8094 7.92616 15.8327 7.63636 15.8327 7.34119C15.8326 4.20723 13.221 1.66669 9.99935 1.66669ZM9.97676 11.1682C7.80398 11.1682 6.04254 9.45477 6.04254 7.34111C6.04254 5.22745 7.80398 3.51406 9.97676 3.51406C12.1495 3.51406 13.911 5.22745 13.911 7.34111C13.911 9.45477 12.1495 11.1682 9.97676 11.1682Z" />
      </g>
      <defs>
        <clipPath id="clip0_883_6883">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Globe: (className: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
    >
      <g>
        <path
          d="M21.8,11.7c-0.1-5.2-4.3-9.4-9.5-9.5l0,0h-0.5l0,0c-5.2,0.1-9.4,4.3-9.5,9.5l0,0v0.5l0,0
		c0.1,5.2,4.3,9.4,9.5,9.5l0,0h0.5l0,0c5.2-0.1,9.4-4.3,9.5-9.5l0,0V11.7L21.8,11.7z M17.4,11.7c0-1.4-0.2-2.7-0.5-3.8h2.8
		c0.6,1.2,1,2.5,1,3.8H17.4z M12.6,20.7c-0.1,0-0.2,0-0.4,0v-4.1h3.9c-0.2,0.6-0.5,1.2-0.8,1.7C14.6,19.6,13.6,20.5,12.6,20.7z
		 M8.6,18.3c-0.3-0.5-0.6-1.1-0.8-1.7h3.9v4.1c-0.1,0-0.2,0-0.4,0C10.3,20.5,9.4,19.6,8.6,18.3z M11.3,3.3c0.1,0,0.2,0,0.4,0v4.1
		H7.9c0.2-0.6,0.5-1.2,0.8-1.7C9.4,4.4,10.3,3.6,11.3,3.3z M15.4,5.7c0.3,0.5,0.6,1.1,0.8,1.7h-3.9V3.3c0.1,0,0.2,0,0.4,0
		C13.6,3.6,14.6,4.4,15.4,5.7z M11.7,7.9v3.8H7.1c0-1.4,0.2-2.6,0.6-3.8C7.7,7.9,11.7,7.9,11.7,7.9z M11.7,12.3v3.8h-4
		c-0.3-1.2-0.5-2.5-0.6-3.8H11.7z M12.3,16.1v-3.8h4.6c0,1.4-0.2,2.6-0.6,3.8H12.3z M12.3,11.7V7.9h4c0.3,1.2,0.5,2.5,0.6,3.8H12.3z
		 M19.4,7.4h-2.7c-0.5-1.6-1.4-3-2.4-3.8C15.7,4,17,4.8,18.1,5.8C18.6,6.3,19,6.8,19.4,7.4z M5.8,5.8c1.1-1,2.4-1.8,3.8-2.2
		c-1,0.8-1.8,2.1-2.4,3.8H4.6C4.9,6.8,5.4,6.3,5.8,5.8z M4.3,7.9h2.8c-0.3,1.2-0.5,2.4-0.5,3.8H3.3C3.3,10.4,3.7,9.1,4.3,7.9z
		 M6.6,12.3c0,1.4,0.2,2.7,0.5,3.8H4.3c-0.6-1.2-1-2.5-1-3.8H6.6z M4.6,16.6h2.7c0.5,1.6,1.4,2.9,2.4,3.8C8.3,20,7,19.2,5.9,18.2
		C5.4,17.7,4.9,17.2,4.6,16.6z M18.2,18.2c-1.1,1.1-2.4,1.8-3.8,2.2c1-0.8,1.8-2.1,2.4-3.8h2.7C19,17.2,18.6,17.7,18.2,18.2z
		 M19.7,16.1h-2.8c0.3-1.2,0.5-2.4,0.5-3.8h3.3C20.7,13.6,20.3,14.9,19.7,16.1z"
        />
      </g>
      <rect fill="none" width="24" height="24" />
    </svg>
  ),
  Timer: (className: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
    >
      <g>
        <g>
          <path
            d="M12,6v2.7c2.4,0,4.4,2,4.4,4.4s-2,4.4-4.4,4.4s-4.4-2-4.4-4.4c0-0.6,0.1-1.2,0.4-1.8l-2-2
       c-0.7,1.1-1.1,2.4-1.1,3.8c0,3.9,3.2,7.1,7.1,7.1s7.1-3.2,7.1-7.1S15.9,6,12,6z"
          />
          <path
            d="M18.7,7.5l0.8-0.8c0.2-0.2,0.2-0.6,0-0.8l-0.4-0.4c-0.2-0.2-0.6-0.2-0.8,0l-0.8,0.8c-1.2-1-2.8-1.7-4.5-1.9
       V3.8h0.8c0.5,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8H10C9.6,2.2,9.3,2.5,9.3,3s0.4,0.8,0.8,0.8h0.8v0.6c-1.7,0.2-3.2,0.9-4.5,2
       L5.6,5.5C5.4,5.3,5,5.3,4.8,5.5L4.4,5.9c-0.2,0.2-0.2,0.6,0,0.8l0.8,0.8C4,9,3.3,11,3.3,13.1c0,4.8,3.9,8.7,8.7,8.7
       s8.7-3.9,8.7-8.7C20.7,11,20,9,18.7,7.5z M12,20.7c-4.2,0-7.6-3.4-7.6-7.6S7.8,5.5,12,5.5s7.6,3.4,7.6,7.6S16.2,20.7,12,20.7z"
          />
          <path d="M12,14.2c0.3,0,0.7-0.2,0.9-0.4l0,0c0.4-0.5,0.2-1.3-0.4-1.7L6.3,8.8l4.8,5C11.4,14.1,11.7,14.2,12,14.2z" />
        </g>
      </g>
      <rect fill="none" width="24" height="24" />
    </svg>
  ),
  Document: (className: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
    >
      <g>
        <path
          d="M5.413,3.23h6.297v5.248h5.246v1.567c0.16-0.022,0.323-0.034,0.489-0.034c0.191,0,0.378,0.015,0.56,0.044
		V7.428L12.76,2.181H4.364v18.891h11.033v-1.049H5.413V3.23z M12.76,3.665l3.762,3.763H12.76V3.665z"
        />
        <path d="M17.607,10.554c-0.034-0.002-0.067-0.003-0.101-0.003C17.539,10.551,17.573,10.552,17.607,10.554z" />
        <path d="M17.737,10.564c-0.026-0.003-0.052-0.004-0.078-0.006C17.685,10.56,17.711,10.561,17.737,10.564z" />
        <path d="M17.659,10.558c-0.017-0.001-0.035-0.003-0.052-0.004C17.624,10.555,17.642,10.557,17.659,10.558z" />
        <path d="M17.841,10.576c-0.035-0.005-0.069-0.009-0.104-0.012C17.772,10.567,17.806,10.571,17.841,10.576z" />
        <path d="M17.869,10.579c-0.009-0.001-0.019-0.002-0.028-0.003C17.85,10.577,17.86,10.578,17.869,10.579z" />
        <path d="M17.869,10.579c0.046,0.006,0.091,0.014,0.137,0.023C17.961,10.593,17.915,10.586,17.869,10.579z" />
        <path d="M17.219,10.558C17.219,10.558,17.219,10.558,17.219,10.558C17.219,10.558,17.219,10.558,17.219,10.558z" />
        <path d="M17.087,10.571c-0.043,0.005-0.087,0.011-0.13,0.018C17,10.582,17.043,10.576,17.087,10.571z" />
        <path
          d="M17.35,10.551c0.042-0.001,0.083-0.002,0.125-0.001c-0.01,0-0.02-0.001-0.03-0.001
		C17.414,10.549,17.382,10.55,17.35,10.551z"
        />
        <path d="M17.35,10.551C17.35,10.551,17.35,10.551,17.35,10.551C17.35,10.551,17.35,10.551,17.35,10.551z" />
        <path d="M17.475,10.55c0.01,0,0.02,0.001,0.03,0.001C17.496,10.551,17.486,10.55,17.475,10.55z" />
        <path d="M17.092,10.571c-0.002,0-0.003,0-0.005,0.001C17.088,10.571,17.09,10.571,17.092,10.571z" />
        <path d="M17.35,10.551c-0.044,0.001-0.088,0.004-0.131,0.007C17.263,10.555,17.306,10.553,17.35,10.551z" />
        <path d="M17.218,10.558c-0.042,0.003-0.085,0.007-0.127,0.012C17.134,10.566,17.176,10.561,17.218,10.558z" />
        <path
          d="M20.371,12.815c-0.176-0.685-0.601-1.299-1.178-1.709c-0.584-0.415-1.313-0.604-2.026-0.54
		c-0.405,0.036-0.803,0.154-1.161,0.348c-0.965,0.524-1.581,1.558-1.581,2.656c0,1.117,0.608,2.09,1.51,2.613v5.693l1.51-1.51h0
		l0.56,0.56v0c0.268,0.268,0.536,0.536,0.805,0.805c0.048,0.048,0.097,0.097,0.145,0.145v-5.693
		c0.225-0.131,0.433-0.289,0.616-0.472C20.328,14.962,20.636,13.846,20.371,12.815z M17.446,15.629
		c-1.136,0-2.059-0.924-2.059-2.059c0-1.136,0.924-2.059,2.059-2.059c1.136,0,2.059,0.924,2.059,2.059
		C19.505,14.705,18.581,15.629,17.446,15.629z"
        />
      </g>
    </svg>
  ),
  Card: (className: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
    >
      <rect y="0" fill="none" width="24" height="24" />
      <g>
        <path
          d="M20.648,5.441H3.352c-0.643,0-1.17,0.526-1.17,1.17v10.206c0,0.643,0.526,1.17,1.17,1.17h17.297
		c0.643,0,1.17-0.526,1.17-1.17V6.611C21.818,5.968,21.292,5.441,20.648,5.441z M3.352,6.532h17.297
		c0.041,0,0.079,0.038,0.079,0.079V8.13H3.273V6.611C3.273,6.57,3.311,6.532,3.352,6.532z M20.648,16.896H3.352
		c-0.041,0-0.079-0.038-0.079-0.079v-5.882h17.455v5.882C20.727,16.857,20.689,16.896,20.648,16.896z"
        />
      </g>
    </svg>
  ),
  Help: (className: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
    >
      <g id="Ebene_1"></g>
      <g id="SWISS_Hintergrund"></g>
      <g id="Symbol">
        <g>
          <rect fill="none" width="24" height="24" />
          <path
            d="M12,3.273C7.18,3.273,3.273,7.18,3.273,12S7.18,20.727,12,20.727S20.727,16.82,20.727,12
  	S16.82,3.273,12,3.273z M12.863,17.671h-2.045v-2.045h2.045V17.671z M15.547,10.61c-0.181,0.308-0.368,0.559-0.559,0.75
  	c-0.319,0.32-0.634,0.573-0.943,0.759c-0.309,0.186-0.559,0.376-0.751,0.567c-0.138,0.139-0.237,0.29-0.295,0.455
  	c-0.059,0.165-0.099,0.434-0.12,0.807l-0.016,0.368h-2.045v-0.512c0-0.234,0.005-0.437,0.016-0.607
  	c0.01-0.17,0.037-0.328,0.08-0.471c0.043-0.144,0.107-0.28,0.192-0.407c0.085-0.129,0.202-0.267,0.352-0.416
  	c0.224-0.224,0.461-0.426,0.711-0.607c0.25-0.181,0.485-0.368,0.703-0.559c0.218-0.191,0.399-0.399,0.543-0.623
  	c0.144-0.224,0.215-0.48,0.215-0.767c0-0.16-0.027-0.33-0.08-0.511c-0.054-0.181-0.141-0.346-0.264-0.495
  	c-0.123-0.15-0.282-0.274-0.479-0.376c-0.197-0.101-0.445-0.152-0.743-0.152c-0.362,0-0.65,0.073-0.863,0.216
  	c-0.213,0.144-0.378,0.307-0.495,0.488c-0.117,0.181-0.197,0.358-0.24,0.527c-0.043,0.172-0.069,0.289-0.08,0.352H8.182
  	c0.011-0.224,0.061-0.511,0.152-0.863c0.09-0.351,0.274-0.689,0.551-1.014c0.277-0.325,0.671-0.605,1.182-0.839
  	c0.511-0.234,1.193-0.351,2.045-0.351c0.532,0,1.025,0.066,1.478,0.199c0.453,0.134,0.844,0.328,1.174,0.584
  	c0.33,0.255,0.588,0.567,0.775,0.933c0.186,0.368,0.28,0.781,0.28,1.239C15.818,9.859,15.728,10.301,15.547,10.61z"
          />
        </g>
      </g>
    </svg>
  ),
  Person: (className: string) => (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19_2285)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0002 9.89138C13.9337 9.89138 15.5003 8.35223 15.5003 6.44542C15.5003 4.53969 13.9337 3 12.0002 3C10.0676 3 8.50061 4.53969 8.50061 6.44542C8.5007 8.35223 10.0677 9.89138 12.0002 9.89138Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.1315 12.1915H13.8691L12.0002 15.8263L10.1318 12.1915H6.86891C5.83509 12.1915 5 13.0097 5 14.0283V20.2307H19.0009V14.0283C19.001 13.0097 18.1664 12.1915 17.1315 12.1915Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_19_2285">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Description: (className: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
    >
      <g>
        <g>
          <path
            d="M13.1,2.2H4.4v19.6h14.2v-1.1V7.6L13.1,2.2z M13.1,3.7L17,7.6h-3.9V3.7z M17.5,20.7h-12V3.3H12v5.5h5.5V20.7z
			"
          />
          <rect x="6.4" y="10.8" width="10" height="1.2" />
          <rect x="6.4" y="13.2" width="8.8" height="1.2" />
          <rect x="6.4" y="15.6" width="10" height="1.2" />
          <rect x="6.4" y="18" width="8.8" height="1.2" />
        </g>
      </g>
      <rect fill="none" width="24" height="24" />
    </svg>
  ),
  Receipt: (className: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
    >
      <g>
        <g>
          <path d="M7.2,19.3c0,0.8,0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4C7.8,18,7.2,18.6,7.2,19.3z" />
          <path d="M15.3,19.3c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4C16,18,15.3,18.6,15.3,19.3z" />
          <path d="M21.1,7.6H6L5.2,4.2C5.2,4.1,5.1,4,5,4H2.3v1.1h2.2l2.7,12h1.4h9.5l0.3-1.1H8l-0.2-1h11L21.1,7.6z" />
        </g>
      </g>
      <rect fill="none" width="24" height="24" />
    </svg>
  ),
  Time: (className: string) => (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_883_6881)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.96975 16.3615C6.44511 16.3615 3.59305 13.5091 3.59305 9.98448C3.59305 6.45977 6.44504 3.60354 9.96975 3.60354C13.4906 3.60354 16.3465 6.45977 16.3465 9.98448C16.3465 13.5091 13.4906 16.3615 9.96975 16.3615ZM9.96975 1.78198C5.43738 1.78198 1.76758 5.45178 1.76758 9.98448C1.76758 14.5129 5.43738 18.1827 9.96975 18.1827C14.4986 18.1827 18.1683 14.5129 18.1683 9.98448C18.1683 5.45178 14.4986 1.78198 9.96975 1.78198Z"
        />
        <path d="M13.7099 6.98544C13.6 6.8755 13.4536 6.8147 13.2981 6.8147C13.142 6.8147 12.9959 6.8755 12.8863 6.98544L9.95492 9.91652L8.13856 8.10048C8.0283 7.99054 7.88225 7.92973 7.72677 7.92973C7.57065 7.92973 7.42492 7.99086 7.31825 8.10048C7.09183 8.32754 7.09183 8.69706 7.31825 8.92412L9.54442 11.15C9.65403 11.2602 9.79976 11.3207 9.95492 11.3207C10.1091 11.3207 10.2548 11.2602 10.3645 11.1505L13.7096 7.80902C13.9366 7.58202 13.9366 7.2125 13.7099 6.98544Z" />
      </g>
      <defs>
        <clipPath id="clip0_883_6881">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Parking: (className: string) => (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_883_6882)">
        <path d="M15.5511 3.65607H4.44923C4.01307 3.65607 3.65625 4.01289 3.65625 4.44905V7.03627V15.5509C3.65625 15.987 4.01307 16.3439 4.44923 16.3439H15.5511C15.9872 16.3439 16.344 15.987 16.344 15.5509V7.03627V4.44905C16.344 4.01289 15.9872 3.65607 15.5511 3.65607ZM13.4471 9.63189C13.2158 10.0425 12.9162 10.3589 12.5481 10.5805C12.1799 10.8025 11.7669 10.9464 11.3092 11.0123C10.8513 11.0786 10.3912 11.1115 9.92879 11.1115H8.79611V14.9342H6.82805V5.06584H9.85798C10.122 5.06584 10.3911 5.07065 10.665 5.08008C10.9386 5.0895 11.21 5.12029 11.4791 5.17199C11.748 5.22401 12.0051 5.3065 12.2506 5.41977C12.496 5.53298 12.7179 5.68884 12.9161 5.88698C13.1615 6.13251 13.3692 6.42743 13.5391 6.77188C13.709 7.11657 13.7939 7.52471 13.7939 7.99659C13.794 8.67618 13.6783 9.22138 13.4471 9.63189Z" />
        <path d="M11.225 6.82856C11.0502 6.72016 10.852 6.64691 10.6304 6.60913C10.4085 6.57154 10.1796 6.55243 9.94366 6.55243H8.79688V9.62481H9.53316C10.0049 9.62481 10.3849 9.59428 10.6729 9.53271C10.9606 9.47145 11.2084 9.33695 11.4162 9.12926C11.5483 8.99719 11.6449 8.83683 11.7065 8.64781C11.7677 8.45923 11.7986 8.25141 11.7986 8.02493C11.7986 7.71339 11.7466 7.46343 11.6428 7.2746C11.5387 7.08583 11.3995 6.93721 11.225 6.82856Z" />
      </g>
      <defs>
        <clipPath id="clip0_883_6882">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Walking: (className: string) => (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_884_6923)">
        <path
          d="M15.6369 10.0966C15.5994 9.94657 15.5019 9.81159 15.3669 9.7291C15.3144 9.7066 13.3272 8.53675 13.0422 8.36427C12.9147 8.06431 11.8873 5.61961 11.8573 5.57462C11.8123 5.46213 11.7299 5.37214 11.6249 5.31215C11.5199 5.25216 11.3999 5.21466 11.2799 5.22216H9.93008C9.82509 5.21466 9.72761 5.22966 9.63012 5.25966C9.53263 5.29715 9.45014 5.36464 9.39015 5.44713C9.34515 5.50713 9.30016 5.56712 9.25516 5.63461C9.12018 5.84458 6.30803 10.2165 6.29303 10.239C6.22554 10.3365 6.19555 10.449 6.20304 10.5615H6.11306C5.96307 10.5615 5.83559 10.689 5.83559 10.839V11.2889H5.37065V14.6785H7.3354L5.97057 16.0433C5.84309 16.1633 5.7756 16.3358 5.7831 16.5083C5.7906 16.8907 6.09806 17.1982 6.48051 17.2057C6.65299 17.2132 6.82547 17.1457 6.95295 17.0182C6.95295 17.0182 8.85022 15.1134 9.12018 14.836C9.39015 14.5585 9.55513 14.401 9.61512 14.3485C9.66761 14.311 9.70511 14.266 9.73511 14.206C9.7651 14.1461 9.7876 14.0786 9.8026 14.0111C9.82509 13.9361 10.455 11.3564 10.515 11.1089H10.7625C10.9125 11.5214 12.9222 16.9882 12.9522 17.0482C13.0122 17.2207 13.1397 17.3632 13.3122 17.4306C13.4771 17.5131 13.6646 17.5206 13.8371 17.4606C14.0096 17.3931 14.1446 17.2582 14.2195 17.0932C14.302 16.9357 14.3095 16.7482 14.2495 16.5758C14.227 16.5008 11.9998 10.404 11.9773 10.329C11.9698 10.314 11.9173 10.149 11.9173 10.149V8.73922C11.9398 8.76922 12.0373 9.05418 12.0823 9.11418C12.1348 9.17417 12.1873 9.23416 12.2473 9.27916C12.3073 9.30165 14.782 10.764 14.782 10.764C14.917 10.839 15.0669 10.854 15.2169 10.809C15.3669 10.764 15.4944 10.6665 15.5769 10.539C15.6594 10.4115 15.6819 10.2465 15.6369 10.0966ZM6.11306 10.839H6.28554C6.41302 11.0564 6.66799 11.1764 6.92296 11.1314C7.07294 11.1014 7.20792 11.0114 7.29041 10.8765C7.29041 10.8765 7.29791 10.8615 7.31291 10.839H7.41789V11.2889H6.11306V10.839ZM9.17268 10.7115C9.16518 10.734 9.09768 11.0114 9.0077 11.3864C8.9402 11.3339 8.85022 11.2964 8.76023 11.2964H8.36278V13.6661L8.1603 13.8686V11.3039H7.69536V10.854C7.69536 10.7265 7.60537 10.614 7.48539 10.584C7.96533 9.82659 9.17268 7.91433 9.17268 7.91433V10.7115ZM9.70511 3.72235C9.70511 3.04743 10.2525 2.5 10.9275 2.5C11.6024 2.5 12.1498 3.04743 12.1498 3.72235C12.1498 4.39726 11.6024 4.9447 10.9275 4.9447C10.2525 4.9447 9.70511 4.38976 9.70511 3.72235ZM4.77072 11.2964H5.16817V14.686H4.77072C4.55325 14.686 4.37327 14.506 4.37327 14.2885V11.6939C4.36577 11.4764 4.54575 11.2964 4.77072 11.2964Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_884_6923">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Bus: (className: string) => (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.08984 16.3582H15.9118V5.45154H4.08984V16.3582ZM14.7717 15.6783C14.3951 15.6783 14.0898 15.373 14.0898 14.9963C14.0898 14.6197 14.3951 14.3144 14.7717 14.3144C15.1482 14.3144 15.4535 14.6197 15.4535 14.9963C15.4535 15.373 15.1482 15.6783 14.7717 15.6783ZM14.999 6.13195L14.6261 12.6822C14.5919 12.8357 14.4548 12.9509 14.2911 12.9509H5.70679C5.5431 12.9509 5.40609 12.8357 5.37178 12.6822L4.99892 6.13195H14.999ZM4.54435 13.4111H15.4484V13.8601H14.1895L13.6757 14.5419H10.5332H9.44965H6.30716L5.79338 13.8601H4.54435V13.4111ZM5.22618 14.3146C5.6025 14.3146 5.90787 14.6199 5.90787 14.9965C5.90787 15.373 5.6025 15.6783 5.22618 15.6783C4.8496 15.6783 4.54422 15.373 4.54422 14.9965C4.54422 14.6199 4.8496 14.3146 5.22618 14.3146Z" />
      <path d="M15.9081 4.97741C15.9081 4.97741 15.7327 3.57213 15.7272 3.54666C15.6841 3.34718 15.5006 3.18176 15.2262 3.18176C14.9638 3.18176 4.77706 3.18176 4.77167 3.18176C4.49182 3.18176 4.31383 3.34712 4.27059 3.54666C4.26521 3.57213 4.08984 4.99999 4.08984 4.99999L15.9081 4.97741ZM5.00566 3.62659H14.9989V4.54368H5.00566V3.62659Z" />
      <path d="M3.18107 5.45459C2.93008 5.45459 2.72656 5.65811 2.72656 5.9091C2.72656 6.08472 2.72656 7.23792 2.72656 7.41354C2.72656 7.66459 2.93008 7.86811 3.18107 7.86811C3.43212 7.86811 3.63564 7.66459 3.63564 7.41354C3.63564 7.23792 3.63564 6.08472 3.63564 5.9091C3.63564 5.65805 3.43212 5.45459 3.18107 5.45459Z" />
      <path d="M16.8178 5.45459C16.5668 5.45459 16.3633 5.65811 16.3633 5.9091C16.3633 6.08472 16.3633 7.23792 16.3633 7.41354C16.3633 7.66459 16.5668 7.86811 16.8178 7.86811C17.0688 7.86811 17.2724 7.66459 17.2724 7.41354C17.2724 7.23792 17.2724 6.08472 17.2724 5.9091C17.2724 5.65805 17.0688 5.45459 16.8178 5.45459Z" />
      <path d="M14.5333 17.7348C15.2458 17.7348 15.8299 17.4748 15.8909 16.8091H13.1758C13.2368 17.4748 13.8209 17.7348 14.5333 17.7348Z" />
      <path d="M5.45678 17.7273C6.16664 17.7273 6.74936 17.4694 6.81395 16.8091H4.09961C4.16426 17.4694 4.74693 17.7273 5.45678 17.7273Z" />
    </svg>
  ),
  Train: (className: string) => (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.2127 14.9355C13.0445 14.9755 12.8693 14.9973 12.689 14.9973H7.28393C7.10947 14.9973 6.93975 14.9768 6.77645 14.9393L4.66016 18.1703H6.03112L6.52219 17.446H13.4694L13.9605 18.1703H15.3315L13.2127 14.9355ZM7.13102 16.548L7.72632 15.67H10.0247H10.0346H12.2654L12.8607 16.548H7.13102Z" />
      <path d="M7.33488 2.33465C7.36272 2.30681 7.44527 2.27269 7.48459 2.27269H8.4446L8.961 2.95445H11.0347L11.5485 2.27269H12.508C12.5473 2.27269 12.6298 2.30681 12.6576 2.33465L12.9836 2.66062L13.3051 2.33927L12.979 2.01323C12.8659 1.90015 12.6678 1.81812 12.508 1.81812H7.48465C7.32481 1.81812 7.12674 1.90015 7.01353 2.01323L6.6875 2.33927L7.00898 2.66062L7.33488 2.33465Z" />
      <path d="M7.2733 14.5455L12.7279 14.5483C13.7536 14.5483 14.5362 13.753 14.5362 12.7273V8.82556L14.0914 5.21195C14.0914 5.21195 14.0421 4.88226 13.9889 4.78271C13.8358 4.49626 13.5342 4.30127 13.1868 4.30127C13.1131 4.30127 12.7289 4.30088 12.6002 4.30127C12.6002 4.30127 12.5896 4.30127 12.5705 4.30127C12.5376 4.01404 12.5101 3.77691 12.508 3.7671C12.4649 3.56762 12.2908 3.41727 12.0802 3.40989C12.0747 3.4097 12.0694 3.40906 12.064 3.40906C12.0585 3.40906 12.0533 3.4097 12.0479 3.40989H7.94352C7.938 3.4097 7.93274 3.40906 7.92735 3.40906C7.92184 3.40906 7.91658 3.4097 7.91119 3.40989C7.70061 3.41727 7.52647 3.56762 7.48324 3.7671C7.48118 3.77691 7.45373 4.01404 7.42083 4.30127C7.05362 4.30127 6.81905 4.30127 6.80462 4.30127C6.45723 4.30127 6.15557 4.49626 6.00246 4.78271C5.94929 4.88226 5.90003 5.21195 5.90003 5.21195L5.45508 8.82556V12.7273C5.45514 13.7424 6.25967 14.5455 7.2733 14.5455ZM7.28267 13.6364C6.78185 13.6328 6.37641 13.2272 6.37282 12.7266C6.37641 12.2292 6.78185 11.8233 7.28267 11.8269C7.7797 11.8233 8.18565 12.2292 8.18238 12.7266C8.18565 13.2272 7.7797 13.6328 7.28267 13.6364ZM12.7286 13.6364C12.2278 13.6328 11.8224 13.2272 11.8188 12.7266C11.8224 12.2292 12.2278 11.8233 12.7286 11.8269C13.2256 11.8233 13.6316 12.2292 13.6283 12.7266C13.6316 13.2272 13.2256 13.6328 12.7286 13.6364ZM8.63695 4.2005C8.63695 4.01757 8.79378 3.8669 8.97382 3.86363H11.0274C11.2074 3.8669 11.3643 4.01757 11.3643 4.2005V4.77271H8.63695V4.2005ZM6.7442 5.72553C6.77877 5.57082 6.91693 5.45453 7.08197 5.45453H12.9094C13.0743 5.45453 13.2126 5.57076 13.2471 5.72553L13.623 8.82793H6.36833L6.7442 5.72553Z" />
    </svg>
  ),
  Cross: (className: string) => (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3182 6.27018L13.7308 4.68274L10.0009 8.41264L6.27103 4.68274L4.68359 6.27018L8.41349 10.0001L4.68359 13.73L6.27103 15.3174L10.0009 11.5875L13.7308 15.3174L15.3182 13.73L11.5883 10.0001L15.3182 6.27018Z"
        fill="black"
      />
    </svg>
  ),
  HandShake: (className: string) => (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.92278 9.87205C3.92278 9.1554 3.92278 8.43875 3.92278 7.72215C3.92278 7.53666 3.92278 7.35116 3.92278 7.16566C3.92278 7.00422 3.92836 6.84098 3.90784 6.68037C3.87115 6.39308 3.7183 6.12836 3.46584 5.97904C3.35359 5.91266 3.22627 5.87308 3.09593 5.86609H1.81836V14.6805L2.77131 14.6818C2.93019 14.6818 3.09337 14.6897 3.24923 14.653C3.52998 14.5871 3.74748 14.362 3.85107 14.0989C3.90315 13.9666 3.92272 13.8293 3.92278 13.6878C3.92285 13.5068 3.92259 13.326 3.92265 13.145C3.92265 12.7825 3.92265 12.42 3.92265 12.0576C3.92278 11.3291 3.92278 10.6006 3.92278 9.87205Z" />
      <path d="M16.9782 6.42639C16.7189 6.43736 16.483 6.57411 16.3265 6.77814C16.2471 6.88167 16.1879 7.00052 16.1525 7.12611C16.1128 7.2669 16.1142 7.40801 16.1142 7.55304C16.1144 8.30459 16.1085 12.7919 16.1095 13.1658C16.1103 13.4638 16.1018 13.7559 16.2648 14.0178C16.4138 14.2573 16.666 14.4247 16.9493 14.4483C17.1493 14.4649 18.1819 14.4513 18.1819 14.4513C18.1819 13.3922 18.1819 6.98712 18.1819 6.42639H16.9782Z" />
      <path d="M15.5087 7.11275L9.8025 7.11243C9.59776 7.11243 9.39828 7.12641 9.20624 7.20389C9.02933 7.27528 8.87251 7.39228 8.75051 7.53865C8.69105 7.60991 8.63987 7.6881 8.5983 7.7711C8.13931 8.68935 7.68031 9.6076 7.22137 10.5259C7.17571 10.6172 7.12215 10.7079 7.08463 10.8031C7.05467 10.8791 7.04396 10.9633 7.10457 11.0275C7.17429 11.1015 7.29078 11.1331 7.38532 11.1596C7.49436 11.1903 7.60462 11.2176 7.71661 11.2349C8.17362 11.3056 8.64968 11.2276 9.05974 11.0138C9.45447 10.8081 9.75478 10.4927 9.97087 10.1065C10.0252 10.0094 10.0754 9.91016 10.1252 9.81074C10.1705 9.7203 10.2066 9.62453 10.2308 9.58162C10.2757 9.50222 10.385 9.49298 10.4499 9.49548C10.4499 9.49548 10.6952 9.4949 10.8172 9.49465C11.0426 9.49413 11.2703 9.47669 11.4783 9.57906C11.6813 9.67893 11.8313 9.86205 11.9886 10.0193C12.3542 10.385 12.7199 10.7507 13.0856 11.1163C13.8101 11.8409 15.511 13.5429 15.511 13.5429L15.5061 7.11365C15.5056 7.11332 15.5092 7.11313 15.5087 7.11275Z" />
      <path d="M11.2672 10.1663C11.2094 10.1086 11.1223 10.1059 11.0458 10.1075C10.972 10.109 10.8982 10.1054 10.8245 10.1071C10.7451 10.109 10.6714 10.1265 10.623 10.1942C10.572 10.2656 10.5406 10.3543 10.4967 10.4305C10.3056 10.7619 10.0503 11.0562 9.74727 11.2899C9.1716 11.7336 8.43474 11.946 7.71199 11.851C7.30322 11.7972 6.93421 11.6418 6.5559 11.4873C6.4035 11.4251 6.2604 11.3323 6.26111 11.149C6.26149 11.0568 6.30755 10.9773 6.34693 10.8967C6.39298 10.8024 7.85567 7.87906 7.95028 7.68746C8.03116 7.52365 8.1139 7.35951 8.22474 7.21346C8.41967 6.9567 8.68412 6.756 8.98245 6.63445C9.13363 6.57288 9.29296 6.5315 9.45498 6.51175C9.64458 6.48859 9.83765 6.49764 10.0282 6.49764C10.4623 6.49764 11.5499 6.49931 11.6596 6.49886C11.7396 6.49854 11.835 6.51245 11.9082 6.47224C11.9756 6.43523 12.0063 6.3639 12.0342 6.2963C12.073 6.20214 12.1069 6.10592 12.1353 6.00811C12.1898 5.82017 12.2266 5.62313 12.2375 5.4275C12.248 5.23873 12.2168 5.05342 12.103 4.89827C11.8698 4.58025 11.4949 4.61329 11.1438 4.61438C10.7163 4.61572 8.11948 4.61425 7.90204 4.61431C7.72129 4.61431 7.54189 4.61123 7.36345 4.64452C7.04376 4.70411 6.74236 4.85324 6.50491 5.076C6.2282 5.33558 6.08542 5.684 5.9193 6.01735C5.87087 6.11452 5.82251 6.21176 5.77382 6.3088C5.73425 6.38763 5.70231 6.47634 5.63335 6.53433C5.50789 6.6399 5.28423 6.61495 5.11952 6.61495C5.01054 6.61495 4.54333 6.61489 4.54333 6.61489C4.54333 6.61489 4.54256 6.63907 4.54327 6.66511C4.54474 6.72027 4.54333 13.9919 4.54333 13.9919L6.63185 13.992C6.63185 13.992 6.72928 13.9907 6.75737 13.9993C6.78681 14.0082 6.81266 14.0426 6.83704 14.0673C6.91208 14.1434 6.98815 14.2184 7.06371 14.294C7.21271 14.443 7.80666 15.0434 7.95688 15.1924C8.0928 15.3271 8.22808 15.4638 8.38849 15.5697C8.69612 15.7728 9.07038 15.8753 9.43862 15.8436C9.64522 15.8258 9.84015 15.7633 10.0368 15.7016C10.2467 15.6356 14.3934 14.2715 14.517 14.2056C14.7431 14.0849 14.9335 13.8859 14.6898 13.5879C14.6216 13.5041 11.5633 10.4626 11.2672 10.1663Z" />
    </svg>
  ),
};
